import React, { useState, useEffect } from 'react';
import './completedProd.css';
import dateP from '../../assets/products/dateP.png';
import Header from '../../components/header';
import { connect } from 'react-redux';
import api from '../../api/api';
import { useParams, useHistory } from 'react-router-dom';
import reddate from '../../assets/products/reddate.png';
import Loader from '../../components/loader';
import { ErrorMessageHandling } from '../../components/error.js';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import config from '../../config.js';
import ApiURL from '../../api/url.js';
import AudioPlayer from '../../services/AudioPlayer';

const CompletedProd = (props) => {
  const { t } = useTranslation();
  let { id } = useParams();
  const [subjectDetail, setsubjectDetail] = useState([]);
  const [liveClassList, setLiveClassList] = useState([]);
  const [loader, setloader] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [expandedItems, setExpandedItems] = useState({});
  const [completionStatus, setCompletionStatus] = useState([]); // Track marked_completed status for each item

  // State for AudioPlayer
  const [audioFlag, setAudioFlag] = useState(false);
  const [type, setType] = useState('');
  const [file_name, setFileName] = useState('');
  const [audiofileName, setAudioFileName] = useState('');
  const [youtubeVideoID, setYoutubeVideoID] = useState('');
  const [videoID, setVideoID] = useState('');
  const [otp, setOtp] = useState('');
  const [playbackInfo, setPlaybackInfo] = useState('');

  // Old UI state - read is_content_seq_enabled from auth (login API)
  const isNewUI = props.auth.is_content_seq_enabled === true;
  const [oldSubjectDetail, setOldSubjectDetail] = useState([]);

  const item = props.product?.item;
  const youtubeUrls = item?.youtube_url ? JSON.parse(item.youtube_url) : [];
  const video_Url = item?.video_url;

  const handleVideoClick = async (url) => {
    try {
      let apiUrl = url;

      if (url.includes("youtube.com") || url.includes("youtu.be")) {
        let videoId = url.includes("youtu.be")
          ? url.split("youtu.be/")[1]?.split("?")[0]
          : (url.match(/[?&]v=([^&]+)/) || [])[1];
        if (videoId) {
          apiUrl = `${ApiURL[config.env].YOUTUBE_URL}${videoId}?rel=0&modestbranding=1`;
        }
      } else if (url.includes("vimeo.com")) {
        const vimeoId = url.split("vimeo.com/")[1]?.split("?")[0];
        apiUrl = `https://player.vimeo.com/video/${vimeoId}`;
      } else if (url.endsWith(".mp4") || url.endsWith(".webm") || url.endsWith(".ogg")) {
        apiUrl = url;
      }

      setIframeUrl(apiUrl);
      setIsFullScreen(true);
    } catch (error) {
      console.error("Error making API call:", error);
    }
  };

  const closeVideo = () => {
    setIframeUrl("");
    setIsFullScreen(false);
  };

  useEffect(() => {
    const favicon = document.getElementById("favicon");
    favicon.href = localStorage.getItem('feviconIcon');

    // console.log("CompletedProd useEffect - isNewUI:", isNewUI, "productId:", id);

    if (isNewUI) {
      // New UI: fetch from product-item/details API
      const today = new Date();
      const fromDate = today.toISOString().split('T')[0];
      const toDateObj = new Date(today);
      toDateObj.setDate(toDateObj.getDate() + 7);
      const toDate = toDateObj.toISOString().split('T')[0];

      let request = {
        url: `/prod/product-item/details/${id}?from_date=${fromDate}&to_date=${toDate}`,
        headers: { 'x-prod-inst-id': props.auth.institute_id , 'x-prod-user-id': props.auth.user_id },
      };
      setloader(true);
      api.getCustomAuth(request).then(data => {
        if (data.data.result && data.data.result.item_list) {
          const items = data.data.result.item_list;
          setsubjectDetail(items);
          // Sanitize completion status to respect sequential order:
          // An item can only be completed if all previous items are also completed.
          // This prevents the same file uploaded with different sequence numbers
          // from showing as "completed" when prior items are still pending.
          const initialStatus = [];
          for (let i = 0; i < items.length; i++) {
            if (items[i].is_read === true && (i === 0 || initialStatus[i - 1] === true)) {
              initialStatus.push(true);
            } else {
              initialStatus.push(false);
            }
          }
          setCompletionStatus(initialStatus);
        }
        if (data.data.result && data.data.result.live_class_list) {
          setLiveClassList(data.data.result.live_class_list);
        }
        setloader(false);
      }).catch((err) => {
        setloader(false);
        if (err && err.response && err.response.status === 403) {
          props.dispatch({ type: 'LOGOUT', msg: err.response.data.message });
        } else if (err.response && err.response.data && err.response.data.message) {
          toast.error(err.response.data.message);
        } else {
          toast.error(ErrorMessageHandling(err));
        }
      });
    } else {
      // Old UI: fetch from item-type-description API
      let request = {
        url: `/prod/student-product/item-type-description/${id}`,
        headers: { 'x-prod-inst-id': props.auth.institute_id },
      };
      setloader(true);
      api.getCustomAuth(request).then(data => {
        if (data.data.result) {
          setOldSubjectDetail(data.data.result);
        }
        setloader(false);
      }).catch((err) => {
        setloader(false);
        if (err && err.response && err.response.status === 403) {
          props.dispatch({ type: 'LOGOUT', msg: err.response.data.message });
        } else if (err.response && err.response.data && err.response.data.message) {
          toast.error(err.response.data.message);
        } else {
          toast.error(ErrorMessageHandling(err));
        }
      });
    }
  }, []);

  const moment = require('moment');
  let dates = props.product.item.enrolled_date;
  let newdate = dates.split("T")[0];
  var dateString = moment(newdate).format('DD-MM-YYYY');

  let date = props.product.item.expire_on;
  let newdates = date ? date.split("T")[0] : '-';
  var dateStrings = moment(newdates).format('DD-MM-YYYY');

  const history = useHistory();

  const Course = (course) => {
    if (course && Array.isArray(course)) {
      return course.map((item, index) =>
        index < course.length - 1 ? item.course_type + ',' : item.course_type
      ).join('');
    } else {
      return '-';
    }
  };

  // Toggle accordion item
  const toggleItem = (index) => {
    setExpandedItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  // Check if an item is unlocked (can be marked as complete)
  const isItemUnlocked = (index) => {
    // First item is always unlocked if not completed
    if (index === 0) return true;
    // Item is unlocked if the previous item is completed
    return completionStatus[index - 1] === true;
  };

  // Mark item as complete (update read status)
  const handleMarkComplete = (item, index) => {
    // Prevent marking if item is locked or already completed
    if (!isItemUnlocked(index) || completionStatus[index]) {
      return;
    }

    setloader(true);

    // Determine source_item_id based on item type
    // For tests: use test_id, for other items: use file_id
    const sourceItemId = item.test_id || item.file_id;

    let request = {
      url: `/prod/product-item/update-read-status`,
      headers: {
        'x-prod-inst-id': props.auth.institute_id,
        'x-prod-user-id': props.auth.user_id
      },
      data: {
        product_id: id,
        source_item_id: sourceItemId,
        slug_type: item.slug_type,
        read_status: 1
      }
    };

    api.putCustomAuth(request).then(response => {
      setloader(false);
      // Update local completion status
      setCompletionStatus(prev => {
        const newStatus = [...prev];
        newStatus[index] = true;
        return newStatus;
      });
      toast.success("Item marked as completed!");
    }).catch((err) => {
      setloader(false);
      if (err && err.response && err.response.status === 403) {
        props.dispatch({ type: 'LOGOUT', msg: err.response.data.message });
      } else if (err.response && err.response.data && err.response.data.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error(ErrorMessageHandling(err));
      }
    });
  };

  // Get icon based on content type
  const getContentIcon = (type, slug_type) => {
    if (type === "Mock Test" || type === "Online Test") return "📝";
    if (type === "Video Lecture" || slug_type === "Videos") return "🎥";
    if (type === "Study Material") {
      if (slug_type === "Images") return "🖼️";
      if (slug_type === "eBook") return "📚";
      return "📄";
    }
    if (type === "Live Class") return "📹";
    if (type === "Classroom Classes") return "🏫";
    if (type === "Printed Materials") return "📚";
    return "📋";
  };

  // Function to close AudioPlayer
  const audiocancle = (flag) => {
    setAudioFlag(flag);
  };

  // Function to get file extension
  const getFileExtension = (filename) => {
    if (!filename) return '';
    // Remove query parameters if present
    const cleanFilename = filename.split('?')[0];
    const parts = cleanFilename.split('.');
    if (parts.length < 2) return '';
    return parts.pop().toLowerCase();
  };

  // Function to handle media click and open AudioPlayer
  const handleMediaClick = (item) => {
    const { slug_type, data_value, youtube_video_id, vimeo_video_id, vdocipher_video_id, file_url } = item;


    // YouTube Video
    if (slug_type === "Videos" && data_value === "Youtube URL" && youtube_video_id) {
      setType("youtube");
      setYoutubeVideoID(youtube_video_id);
      setAudioFlag(true);
      return;
    }

    // Vimeo Video
    if (slug_type === "Videos" && data_value === "Vimeo" && vimeo_video_id) {
      setType("vimeo");
      setVideoID(vimeo_video_id);
      setAudioFlag(true);
      return;
    }

    // Vdocipher Video - would need OTP
    if (vdocipher_video_id) {
      toast.info("Vdocipher video playback requires authentication");
      return;
    }

    // For all files with file_url, determine type based on actual extension
    if (file_url) {
      const fileExt = getFileExtension(file_url);

      // Handle images (check extension first, regardless of slug_type)
      if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(fileExt)) {
        setType("image");
        setFileName(file_url);
        setAudioFlag(true);
        return;
      }

      // Handle documents (PDF, Office files)
      if (['pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'txt'].includes(fileExt)) {
        setType("file");
        setFileName(file_url);
        setAudioFlag(true);
        return;
      }

      // Handle audio files
      if (['mp3', 'aac', 'wav', 'ogg', 'flac', 'm4a'].includes(fileExt)) {
        setType("audio");
        setAudioFileName(file_url);
        setAudioFlag(true);
        return;
      }

      // Handle video files
      if (['mp4', 'webm', 'mov', 'avi', 'mkv'].includes(fileExt)) {
        setType("mp4");
        setFileName(file_url);
        setAudioFlag(true);
        return;
      }

      // Handle unsupported files
      if (['pbix', 'zip', 'rar', '7z', 'exe', 'dmg'].includes(fileExt)) {
        toast.error("Preview not supported. Please download the file.");
        setType("unsupported");
        setFileName(file_url);
        setAudioFlag(true);
        return;
      }

      // Default: try to open as file (for any other extension)
      setType("file");
      setFileName(file_url);
      setAudioFlag(true);
      return;
    }

    toast.info("Unable to preview this file type");
  };

  // Function to handle Live Class join
  const handleJoinLiveClass = (liveClass) => {
    if (props.auth.parentslogin) {
      toast.error("Parents are not allowed to join.");
      return;
    }

    // Use meeting_id as session_id for the API call
    const sessionId = liveClass.session_id;
    if (!sessionId) {
      toast.error("Meeting ID not found");
      return;
    }

    setloader(true);
    const queryParam = liveClass.class_type === "zoom"
      ? "?isZoomLiveClass=1"
      : liveClass.class_type === "webex"
        ? "?isWebexLiveClass=1"
        : "";

    let request = {
      url: `/api/v1/meeting_manager/session/start/${props.auth.institute_id}/${sessionId}${queryParam}`,
      token: props.auth.student_auth,
    };


    api.getAuth(request).then(data => {
      setloader(false);
      if (data.data.result.allow_start_session) {
        window.open(liveClass.join_url, '_blank');
      } else {
        toast.error("You cannot start the class as the classes can only be started after the scheduled time.");
      }
    }).catch((err) => {
      setloader(false);
      if (err && err.response && err.response.status === 403) {
        props.dispatch({ type: 'LOGOUT', msg: err.response.data.message });
      } else if (err.response && err.response.data && err.response.data.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Network error");
      }
    });
  };

  // Function to calculate time difference and status
  const getTimeDifference = (start_time, end_time) => {
    let diff = new Date(end_time).getTime() - new Date(start_time).getTime();
    let minutes = diff / 60000;
    return minutes;
  };

  const remainingTime = (time) => {
    const start_datetime = new Date(time);
    const current_time = new Date();

    const totalSeconds = Math.floor((start_datetime - current_time) / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const totalHours = Math.floor(totalMinutes / 60);
    const totalDays = Math.floor(totalHours / 24);

    const hours = totalHours - (totalDays * 24);
    const minutes = totalMinutes - (totalDays * 24 * 60) - (hours * 60);
    const seconds = totalSeconds - (totalDays * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);

    if (totalDays > 0) {
      return totalDays + (totalDays > 1 ? ' Days' : ' Day');
    } else if (hours > 0) {
      return hours + ' hrs ' + minutes + (minutes > 1 ? ' Mins' : ' Min');
    } else if (minutes > 0) {
      return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + seconds + (seconds > 1 ? ' Secs' : 'Sec');
    } else {
      return seconds + (seconds > 1 ? ' Secs' : 'Sec');
    }
  };

  const convertMinsToHrsMins = (mins) => {
    let h = Math.floor(mins / 60);
    let m = Math.round(mins % 60);
    h = (h < 10) ? ('0' + h) : (h);
    m = (m < 10) ? ('0' + m) : (m);
    return `${h}:${m}`;
  };

  // Function to get class status (Ongoing, Upcoming, or Ended)
  const getClassStatus = (startTime, endTime) => {
    const now = new Date();
    const start = new Date(startTime);
    const end = new Date(endTime);

    if (now >= start && now <= end) {
      return { status: 'Ongoing', canJoin: true };
    } else if (now < start) {
      return { status: 'Upcoming', canJoin: false, timeLeft: remainingTime(startTime) };
    } else {
      return { status: 'Ended', canJoin: false };
    }
  };

  // Function to render media content based on type
  const renderMediaContent = (item) => {
    const { slug_type, data_value, youtube_video_id, vimeo_video_id, vimeo_video_url, vimeo_video_thumbnail,
            vdocipher_video_id, file_url, test_id, is_read_only, type: itemType, topic_nm, strd_nm, sub_nm } = item;

    // YouTube Video - Show thumbnail (smaller size)
    if (slug_type === "Videos" && data_value === "Youtube URL" && youtube_video_id) {
      const thumbnail = `https://img.youtube.com/vi/${youtube_video_id}/hqdefault.jpg`;
      return (
        <div
          className="media-content"
          style={{ maxWidth: '280px', marginTop: '10px', cursor: 'pointer', position: 'relative' }}
          onClick={() => handleMediaClick(item)}
        >
          <img
            src={thumbnail}
            alt={item.name}
            style={{
              width: '100%',
              height: '140px',
              objectFit: 'cover',
              borderRadius: '6px',
              border: '1px solid #e0e0e0'
            }}
          />
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '36px',
            color: 'white',
            textShadow: '0 0 10px rgba(0,0,0,0.5)'
          }}>▶</div>
        </div>
      );
    }

    // Vimeo Video - Show thumbnail or play button (Video Lecture type - non-YouTube videos)
    if (slug_type === "Videos" && data_value === "Vimeo" && vimeo_video_id) {
      let thumbnail = null;
      try {
        if (vimeo_video_thumbnail) {
          const thumbnails = JSON.parse(vimeo_video_thumbnail);
          if (thumbnails && thumbnails.length > 0) {
            thumbnail = thumbnails[0].link;
          }
        }
      } catch (e) {
        console.error("Error parsing vimeo thumbnail", e);
      }

      // Note: Vimeo videos are typically part of "Video Lecture" type
      // For now, only showing play button. Download option would need Vimeo API support.
      return (
        <div
          className="media-content"
          style={{ maxWidth: '280px', marginTop: '10px', cursor: 'pointer', position: 'relative' }}
          onClick={() => handleMediaClick(item)}
        >
          {thumbnail ? (
            <img
              src={thumbnail}
              alt={item.name}
              style={{
                width: '100%',
                height: '140px',
                objectFit: 'cover',
                borderRadius: '6px',
                border: '1px solid #e0e0e0'
              }}
            />
          ) : (
            <div style={{
              width: '100%',
              height: '140px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: '#f0f0f0',
              borderRadius: '6px',
              border: '1px solid #e0e0e0'
            }}>
              <span style={{ fontSize: '36px', color: '#666' }}>▶</span>
            </div>
          )}
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '36px',
            color: 'white',
            textShadow: '0 0 10px rgba(0,0,0,0.5)'
          }}>▶</div>
        </div>
      );
    }

    // Vdocipher Video
    if (vdocipher_video_id) {
      return (
        <div
          className="media-content"
          style={{ maxWidth: '400px', marginTop: '10px', padding: '8px 12px', background: '#f9f9f9', borderRadius: '6px', fontSize: '13px', cursor: 'pointer' }}
          onClick={() => handleMediaClick(item)}
        >
          <p style={{ margin: 0, color: '#666', fontSize: '13px' }}>Vdocipher Video - Playback requires OTP authentication</p>
          <small style={{ color: '#999', fontSize: '11px' }}>Video ID: {vdocipher_video_id}</small>
        </div>
      );
    }

    // eBook - Show View and Download buttons (check is_read_only for Study Material)
    if (slug_type === "eBook" && file_url) {
      const fileExt = getFileExtension(file_url);
      // Check if download should be shown based on is_read_only
      const showDownload = itemType === "Study Material" ? is_read_only === "N" : true;

      return (
        <div className="media-content" style={{ marginTop: '10px' }}>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <button
              onClick={() => handleMediaClick(item)}
              style={{
                padding: '8px 16px',
                background: '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                fontSize: '13px',
                cursor: 'pointer',
                fontWeight: '500'
              }}
            >
              View {fileExt ? fileExt.toUpperCase() : 'eBook'}
            </button>
            {showDownload && (
              <a
                href={file_url}
                download
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  padding: '8px 16px',
                  background: '#007bff',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '5px',
                  fontSize: '13px',
                  fontWeight: '500'
                }}
              >
                Download
              </a>
            )}
          </div>
        </div>
      );
    }

    // Images - Show thumbnail with View and Download buttons (check is_read_only for Study Material)
    if (slug_type === "Images" && file_url) {
      // Check if download should be shown based on is_read_only
      const showDownload = itemType === "Study Material" ? is_read_only === "N" : true;

      return (
        <div className="media-content" style={{ marginTop: '10px' }}>
          <div
            style={{ maxWidth: '280px', cursor: 'pointer', marginBottom: '10px' }}
            onClick={() => handleMediaClick(item)}
          >
            <img
              src={file_url}
              alt={item.name}
              style={{
                width: '100%',
                maxHeight: '160px',
                objectFit: 'contain',
                borderRadius: '6px',
                border: '1px solid #e0e0e0',
                background: '#f9f9f9'
              }}
            />
          </div>
          <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
            <button
              onClick={() => handleMediaClick(item)}
              style={{
                padding: '8px 16px',
                background: '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                fontSize: '13px',
                cursor: 'pointer',
                fontWeight: '500'
              }}
            >
              View
            </button>
            {showDownload && (
              <a
                href={file_url}
                download
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  padding: '8px 16px',
                  background: '#007bff',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '5px',
                  fontSize: '13px',
                  fontWeight: '500'
                }}
              >
                Download
              </a>
            )}
          </div>
        </div>
      );
    }

    // PDF and Office Files - Show View and Download buttons (check is_read_only for Study Material and Video Lecture)
    if (file_url) {
      const fileExt = getFileExtension(file_url);

      if (['pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].includes(fileExt)) {
        // Check if download should be shown based on is_read_only
        // For "Study Material" and "Video Lecture" types (excluding YouTube), check is_read_only
        const showDownload = (itemType === "Study Material" || itemType === "Video Lecture")
          ? is_read_only === "N"
          : true;

        return (
          <div className="media-content" style={{ marginTop: '10px' }}>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              <button
                onClick={() => handleMediaClick(item)}
                style={{
                  padding: '8px 16px',
                  background: '#28a745',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  fontSize: '13px',
                  cursor: 'pointer',
                  fontWeight: '500'
                }}
              >
                View {fileExt.toUpperCase()}
              </button>
              {showDownload && (
                <a
                  href={file_url}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-block',
                    padding: '8px 16px',
                    background: '#007bff',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '5px',
                    fontSize: '13px',
                    fontWeight: '500'
                  }}
                >
                  Download
                </a>
              )}
            </div>
          </div>
        );
      }

      // Other downloadable files (no preview available)
      return (
        <div className="media-content" style={{ marginTop: '10px' }}>
          <a
            href={file_url}
            download
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              padding: '8px 16px',
              background: '#007bff',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '5px',
              fontSize: '13px',
              fontWeight: '500'
            }}
          >
            Download {item.name}
          </a>
        </div>
      );
    }

    // Test
    if (test_id) {
      // Function to start test
      const handleStartTest = () => {
        if (props.auth.parentslogin) {
          toast.error("Parents are not allowed to give exam");
          return;
        }

        // Generate auth token same as exam module
        let authToken = props.auth.institute_id + ":" + test_id + ":" + props.auth.user_id + ":" + props.auth.password;
        authToken = btoa(authToken);  // Base64 encode
        authToken = authToken.replaceAll("=", "$");  // Replace = with $

        // Get test panel URL based on demo account status
        // const testPanelUrl = props.auth.demo_account
        //   ? URL[config.env].WEB_TEST_PANEL_URL2
        //   : URL[config.env].WEB_TEST_PANEL_URL;
        const testPanelUrl = ApiURL[config.env].WEB_TEST_PANEL_URL2;
        // Open test panel in new window
        window.open(
          testPanelUrl + "/" + authToken,
          'location=yes,scrollbars=yes,status=yes'
        );
      };

      return (
    

        <div className="media-content" style={{ maxWidth: '400px', marginTop: '10px' }}>
          {/* Display test details: topic, standard, subject */}
          {(topic_nm || strd_nm || sub_nm) && (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '6px',
              marginBottom: '12px',
              padding: '10px',
              background: '#f9f9f9',
              borderRadius: '6px',
              fontSize: '13px',
              color: '#666'
            }}>
              {topic_nm && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <span style={{ fontWeight: '600', color: '#555' }}>Topic:</span>
                  <span>{topic_nm}</span>
                </div>
              )}
              {strd_nm && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <span style={{ fontWeight: '600', color: '#555' }}>Standard:</span>
                  <span>{strd_nm}</span>
                </div>
              )}
              {sub_nm && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <span style={{ fontWeight: '600', color: '#555' }}>Subject:</span>
                  <span>{sub_nm}</span>
                </div>
              )}
            </div>
          )}

          <button
            onClick={handleStartTest}
            style={{
              display: 'inline-block',
              padding: '10px 20px',
              background: props.auth.parentslogin ? '#e3e3e3' : '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: props.auth.parentslogin ? 'not-allowed' : 'pointer',
              transition: 'background 0.3s ease'
            }}
            onMouseOver={(e) => {
              if (!props.auth.parentslogin) {
                e.target.style.background = '#0056b3';
              }
            }}
            onMouseOut={(e) => {
              if (!props.auth.parentslogin) {
                e.target.style.background = '#007bff';
              }
            }}
          >
            Start Test
          </button>
          <p style={{ margin: '8px 0 0 0', color: '#666', fontSize: '12px' }}>
            Test ID: {test_id}
          </p>
        </div>
      );
    }

    return null;
  };

  return (
    <>
      {loader && <Loader />}

      {/* AudioPlayer for videos, images, and documents */}
      {audioFlag && (
        <AudioPlayer
          audiofileName={audiofileName}
          audiocancle={audiocancle}
          otp={otp}
          playbackInfo={playbackInfo}
          type={type}
          videoID={videoID}
          youtubeVideoID={youtubeVideoID}
          file_name={file_name}
        />
      )}

      <Header />

      <div className="completed-container">
        {/* ---------------- PRODUCT OVERVIEW SECTION (Udemy-style) ---------------- */}
        <div className="product-overview-section">
          {/* Left: Product Image */}
          <div className="product-image-container">
            <div
              className="product-main-image"
              style={{
                backgroundImage: `url(${props.product.item.photo_url || props.product.item.logo_url})`
              }}
            >
              <div className="price-badge">
                {props.product.item.price === 0
                  ? <p>Free</p>
                  : <p>{props.product.item.price + " " + props.product.currency_code}</p>}
              </div>
            </div>

            {/* Sample Videos Below Image */}
            {(youtubeUrls.length > 0 || video_Url) && (
              <div className="sample-videos-section">
                <h3 style={{fontWeight:"600", fontSize: "16px", marginBottom: "10px", color: "var(--text-color)" }}>Sample Videos</h3>
                <div className="videos-carousel">
                  { (youtubeUrls.length > 1 || video_Url) && (
                    <button className="arrow left" onClick={() => {
                      document.querySelector(".videos-scroll").scrollBy({ left: -300, behavior: "smooth" });
                    }}>‹</button>
                  )}

                  <div className="videos-scroll">
                    {youtubeUrls.map((url, index) => {
                      let thumbnail = "";
                      if (url.includes("youtube.com") || url.includes("youtu.be")) {
                        let videoId = url.includes("youtu.be")
                          ? url.split("youtu.be/")[1]?.split("?")[0]
                          : (url.match(/[?&]v=([^&]+)/) || [])[1];
                        if (videoId) thumbnail = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                      } else if (url.includes("vimeo.com")) {
                        thumbnail = "https://i.vimeocdn.com/video/default.jpg";
                      } else {
                        thumbnail = "/video-placeholder.png";
                      }
                      return (
                        <div
                          key={index}
                          className="youtube-video"
                          onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleVideoClick(url); }}
                        >
                          <img src={thumbnail} alt={`Video ${index + 1}`} />
                        </div>
                      );
                    })}

                    {video_Url && (
                      <div className="youtube-video" onClick={() => handleVideoClick(video_Url)}>
                        <video>
                          <source src={video_Url} type="video/mp4" />
                        </video>
                      </div>
                    )}
                  </div>

                  { (youtubeUrls.length > 1 || video_Url) && (
                    <button className="arrow right" onClick={() => {
                      document.querySelector(".videos-scroll").scrollBy({ left: 300, behavior: "smooth" });
                    }}>›</button>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* Right: Product Details */}
          <div className="product-info-container">
            <button className="goback-top" onClick={() => { window.location = "../product" }}>← Go Back</button>

            <h1 className="product-title">{props.product.item.title}</h1>

            <div className="product-description">
              <p>{props.product.item.about.replace(/<\/?[^>]+(>|$)/g, "")}</p>
            </div>

            <div className="product-meta">
              <div className="meta-item">
                <span className="meta-label">{props.auth.is_institute_type_school ? "Standard:" : "Category/Course:"}</span>
                <span className="meta-value">{Course(props.product.item.product_ecourse_maps)}</span>
              </div>

              <div className="meta-item">
                <span className="meta-label">Order ID:</span>
                <span className="meta-value">{props.product.item.public_order_id}</span>
              </div>

              {props.product.item.is_enrolled && (
                <div className="enrollment-info">
                  <div className="enrollment-item">
                    <img src={dateP} alt="" className="icon" />
                    <div>
                      <span className="enrollment-label">Purchased On</span>
                      <span className="enrollment-value">{dateString}</span>
                    </div>
                  </div>
                  <div className="enrollment-item">
                    <img src={reddate} alt="" className="icon" />
                    <div>
                      <span className="enrollment-label">
                        {props.product.item.expired === false ? "Expiry Date" : "Expired on"}
                      </span>
                      <span className="enrollment-value">{dateStrings}</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ---------------- CONDITIONAL CONTENT SECTION ---------------- */}
        {isNewUI ? (
        <>
        {/* ---------------- NEW UI: PRODUCT CONTENT SECTION (Accordion) ---------------- */}
        <div className="product-content-section">
          <h2 className="content-heading">Product Content</h2>

          {/* Outer container box for all content items */}
          <div className="content-items-container">
            {subjectDetail.map((item, index) => {
            const isUnlocked = isItemUnlocked(index);
            const isCompleted = completionStatus[index] === true;
            const isLocked = !isUnlocked;

            return (
              <div key={index} className={`content-item ${isLocked ? 'item-locked' : ''} ${isCompleted ? 'item-completed' : ''}`}>
                {/* Accordion Header - Only show item.type */}
                <div
                  className={`content-header ${isLocked ? 'header-locked' : ''}`}
                  onClick={() => !isLocked && toggleItem(index)}
                  style={{ cursor: isLocked ? 'not-allowed' : 'pointer' }}
                >
                  <div className="content-header-left">
                    {/* Status indicator */}
                    <span className="item-status-icon">
                      {isCompleted ? (
                        <span style={{ color: '#28a745', fontSize: '18px' }}>&#10003;</span>
                      ) : isLocked ? (
                        <span style={{ color: '#999', fontSize: '16px' }}>&#128274;</span>
                      ) : (
                        <span style={{ color: '#007bff', fontSize: '16px' }}>&#128275;</span>
                      )}
                    </span>
                    <span className="content-icon">{getContentIcon(item.type, item.slug_type)}</span>
                    <div className="content-title-wrapper">
                      <span className="content-type">{item.type}</span>
                      {isCompleted && <span className="completed-badge">Completed</span>}
                      {isLocked && <span className="locked-badge">Locked</span>}
                    </div>
                  </div>
                  <span className="expand-icon">{expandedItems[index] ? "−" : "+"}</span>
                </div>

                {/* Accordion Body (Expanded Content) */}
                {expandedItems[index] && (
                  <div className="content-body">
                    {/* Show item.name inside the content */}
                    <h3 className="content-item-name">{item.name}</h3>

                    {/* Display additional info: topic, standard, subject (except for tests - they show it above Start Test button) */}
                    {!item.test_id && (item.topic_nm || item.strd_nm || item.sub_nm) && (
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '6px',
                        marginBottom: '12px',
                        fontSize: '13px',
                        color: '#666'
                      }}>
                        {item.topic_nm && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{ fontWeight: '600', color: '#555' }}>Topic:</span>
                            <span>{item.topic_nm}</span>
                          </div>
                        )}
                        {item.strd_nm && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{ fontWeight: '600', color: '#555' }}>Standard:</span>
                            <span>{item.strd_nm}</span>
                          </div>
                        )}
                        {item.sub_nm && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{ fontWeight: '600', color: '#555' }}>Subject:</span>
                            <span>{item.sub_nm}</span>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Render media content inline */}
                    {renderMediaContent(item)}

                  {/* Show fallback navigation info only if no media content is available */}
                  {!renderMediaContent(item) && (
                    <>
                      {item.type === "Study Material"
                        ? <div className="content-info">You can find study material by going to Study Material → Purchased product → Select Product</div>
                        : item.type === "Mock Test"
                          ? <div className="content-info">You can find and attempt the test by going to the My Tests → Mock Test → Select Product</div>
                          : item.type === "Live Class"
                            ? <div className="content-info">Live classes will be scheduled by your Institute and will be shown in live class Upcoming Section</div>
                            : item.type === "Classroom Classes"
                              ? <div className="content-info">Classroom classes will be scheduled by your Institute and will be shown in Timetable</div>
                              : item.type === "Printed Materials"
                                ? <div className="content-info">You can find printed material by going to Study Material → Purchased product → Select Product</div>
                                : item.type === "Video Lecture"
                                  ? <div className="content-info">You can find video lectures by going to Study Material → Purchased product → Select Product</div>
                                  : item.type === "Online Test"
                                    ? <div className="content-info">You can find and attempt the test by going to the My Tests → Online Test → Select Product</div>
                                    : <div></div>}
                    </>
                  )}

                  {/* Mark as Complete Button */}
                  <div className="mark-complete-section" style={{ marginTop: '20px', borderTop: '1px solid #e0e0e0', paddingTop: '15px' }}>
                    {isCompleted ? (
                      <div className="completed-message" style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        color: '#28a745',
                        fontWeight: '600',
                        fontSize: '14px'
                      }}>
                        <span style={{ fontSize: '18px' }}>&#10003;</span>
                        <span>Completed</span>
                      </div>
                    ) : (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleMarkComplete(item, index);
                        }}
                        className="mark-complete-btn"
                        style={{
                          padding: '10px 24px',
                          background: '#28a745',
                          color: 'white',
                          border: 'none',
                          borderRadius: '6px',
                          fontSize: '14px',
                          fontWeight: '600',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseOver={(e) => { e.target.style.background = '#218838'; }}
                        onMouseOut={(e) => { e.target.style.background = '#28a745'; }}
                      >
                        <span style={{ fontSize: '16px' }}>&#10003;</span>
                        Mark as Complete
                      </button>
                    )}
                  </div>
                </div>
              )}
              </div>
            );
          })}
          </div>
        </div>

        {/* ---------------- LIVE CLASS SECTION ---------------- */}
        {liveClassList && liveClassList.length > 0 && (
          <div className="product-content-section" style={{ marginTop: '20px' }}>
            <h2 className="content-heading">Live Classes</h2>

            <div className="content-items-container">
              {liveClassList.map((liveClass, idx) => {
                const classStatus = getClassStatus(liveClass.start_datetime, liveClass.end_datetime);
                const duration = getTimeDifference(liveClass.start_datetime, liveClass.end_datetime);
                const formattedDuration = duration < 60
                  ? duration + " Mins"
                  : duration / 60 === 1
                    ? duration / 60 + " Hr"
                    : convertMinsToHrsMins(duration) + " Hr's";

                return (
                  <div
                    key={idx}
                    className="live-class-card"
                    style={{
                      background: 'var(--bg-color)',
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      padding: '15px',
                      marginBottom: '10px',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.08)'
                    }}
                  >
                    {/* Status Badge */}
                    <div
                      style={{
                        display: 'inline-block',
                        padding: '4px 12px',
                        borderRadius: '12px',
                        fontSize: '12px',
                        fontWeight: '600',
                        marginBottom: '10px',
                        background: classStatus.status === 'Ongoing' ? '#28a745' : classStatus.status === 'Upcoming' ? '#C279FC' : '#E1DEDD',
                        color: classStatus.status === 'Ended' ? '#666' : 'white'
                      }}
                    >
                      {classStatus.status === 'Ongoing' && 'Ongoing'}
                      {classStatus.status === 'Upcoming' && classStatus.timeLeft && `${classStatus.timeLeft} Left`}
                      {classStatus.status === 'Ended' && 'Ended'}
                    </div>

                    {/* Topic/Session Name */}
                    <h4 style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: 'var(--text-color)',
                      margin: '0 0 10px 0'
                    }}>
                      {liveClass.topic || 'Live Class'}
                    </h4>

                    {/* Class Details */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '12px' }}>
                      {/* Start Time and Duration */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', fontSize: '13px', color: '#666' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <span>🕒</span>
                          <span>{moment(liveClass.start_datetime).format("hh:mm A")}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <span>•</span>
                          <span>{formattedDuration}</span>
                        </div>
                      </div>

                      {/* Date */}
                      <div style={{ fontSize: '13px', color: '#666' }}>
                        <span>📅</span>
                        <span style={{ marginLeft: '5px' }}>{moment(liveClass.start_datetime).format("DD MMM YYYY")}</span>
                      </div>

                      {/* Batch Name */}
                      {(liveClass.c_nm || liveClass.mc_nm) && (
                        <div style={{ fontSize: '13px', color: '#666' }}>
                          <span>🎓</span>
                          <span style={{ marginLeft: '5px' }}>{liveClass.c_nm || liveClass.mc_nm}</span>
                        </div>
                      )}

                      {/* Class Type */}
                      <div style={{ fontSize: '13px', color: '#666', textTransform: 'capitalize' }}>
                        <span>📹</span>
                        <span style={{ marginLeft: '5px' }}>{liveClass.class_type || 'Live Class'}</span>
                      </div>

                      {/* Recurring Badge */}
                      {liveClass.is_recurring && (
                        <div style={{ fontSize: '12px', color: '#007bff' }}>
                          <span>🔄</span>
                          <span style={{ marginLeft: '5px' }}>Recurring Class</span>
                        </div>
                      )}
                    </div>

                    {/* Join Button */}
                    <button
                      onClick={() => {
                        if (classStatus.canJoin) {
                          handleJoinLiveClass(liveClass);
                        } else if (classStatus.status === 'Upcoming') {
                          toast.error("Grab a cup of Coffee. Class is not yet started.");
                        } else {
                          toast.error("This class has ended.");
                        }
                      }}
                      style={{
                        padding: '8px 20px',
                        background: classStatus.canJoin && !props.auth.parentslogin ? '#28a745' : '#E3E3E3',
                        color: classStatus.canJoin && !props.auth.parentslogin ? 'white' : '#666',
                        border: 'none',
                        borderRadius: '5px',
                        fontSize: '14px',
                        fontWeight: '600',
                        cursor: classStatus.canJoin && !props.auth.parentslogin ? 'pointer' : 'not-allowed',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseOver={(e) => {
                        if (classStatus.canJoin && !props.auth.parentslogin) {
                          e.target.style.background = '#218838';
                        }
                      }}
                      onMouseOut={(e) => {
                        if (classStatus.canJoin && !props.auth.parentslogin) {
                          e.target.style.background = '#28a745';
                        }
                      }}
                    >
                      Join Class
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        </>
        ) : (
        <>
        {/* ---------------- OLD UI: PRODUCT DETAILS (Text descriptions) ---------------- */}
        <div className="product-content-section">
          <h2 className="content-heading">Product Details</h2>
          <div className="content-items-container">
            {oldSubjectDetail.length > 0 ? oldSubjectDetail.map((item, index) => (
              <div key={index} className="content-item" style={{ padding: '15px', borderBottom: '1px solid #e0e0e0' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                  <span className="content-icon">{getContentIcon(item.item_type || item.type, '')}</span>
                  <span style={{ fontSize: '16px', fontWeight: '600', color: 'var(--text-color, #333)' }}>
                    {item.item_type || item.type}
                  </span>
                  {item.count != null && (
                    <span style={{ fontSize: '13px', color: '#666', marginLeft: '5px' }}>({item.count})</span>
                  )}
                </div>
                {item.description && (
                  <p style={{ fontSize: '14px', color: '#666', margin: '5px 0 10px 0', lineHeight: '1.5' }}
                     dangerouslySetInnerHTML={{ __html: item.description }} />
                )}
                <div className="content-info" style={{ fontSize: '13px', color: '#888', background: '#f9f9f9', padding: '10px', borderRadius: '6px' }}>
                  {(item.item_type || item.type) === "Study Material"
                    ? "You can find study material by going to Study Material → Purchased product → Select Product"
                    : (item.item_type || item.type) === "Mock Test"
                      ? "You can find and attempt the test by going to the My Tests → Mock Test → Select Product"
                      : (item.item_type || item.type) === "Live Class"
                        ? "Live classes will be scheduled by your Institute and will be shown in live class Upcoming Section"
                        : (item.item_type || item.type) === "Classroom Classes"
                          ? "Classroom classes will be scheduled by your Institute and will be shown in Timetable"
                          : (item.item_type || item.type) === "Printed Materials"
                            ? "You can find printed material by going to Study Material → Purchased product → Select Product"
                            : (item.item_type || item.type) === "Video Lecture"
                              ? "You can find video lectures by going to Study Material → Purchased product → Select Product"
                              : (item.item_type || item.type) === "Online Test"
                                ? "You can find and attempt the test by going to the My Tests → Online Test → Select Product"
                                : "Please check the respective section in the app to access this content"}
                </div>
              </div>
            )) : (
              <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>No product details available</div>
            )}
          </div>
        </div>
        </>
        )}

        {/* ✅ Video Modal */}
        {iframeUrl && (
          <div className={`video-container ${isFullScreen ? "fullscreen" : ""}`}
            style={{ marginTop: "20px", textAlign: "center" }}>
            <button
              onClick={closeVideo}
              style={{
                position: "absolute",
                top: "10px",
                right: "20px",
                background: "transparent",
                color: "white",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
                zIndex: 2000,
              }}
            >✖</button>

            {iframeUrl.endsWith(".mp4") || iframeUrl.endsWith(".webm") || iframeUrl.endsWith(".ogg") ? (
              <video controls autoPlay style={{ width: "80%", height: "80%", borderRadius: "8px" }}>
                <source src={iframeUrl} />
              </video>
            ) : (
              <iframe
                width="80%"
                height="80%"
                src={iframeUrl}
                className="video-iframe"
                allow="autoplay; encrypted-media"
                allowFullScreen
                title="Video"
                style={{ borderRadius: '8px', boxShadow: '0 0 10px rgba(0,0,0,0.3)' }}
              ></iframe>
            )}
          </div>
        )}
      </div>

      <ToastContainer />
    </>
  );
};

const mapStateToProps = state => ({ auth: state.auth, product: state.product.data });
export default connect(mapStateToProps)(CompletedProd);
